export default "__VITE_ASSET__D0zclU0B__"